import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useImperativeHandle, useMemo } from 'react';
import { ChipCollection } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import styles from './IntentStep.module.scss';
export const GetIntentStepTID = (parentTestId)=>getTestIds({
        parentTestId
    });
const intentStepTextsPath = 'vendorOnboarding.intentStep';
export const IntentStep = (param)=>{
    let { testId, values, onChange, onContinue, submitRef } = param;
    const testIds = useMemo(()=>GetIntentStepTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys(intentStepTextsPath);
    const { api, logBI } = useStoreActions();
    const options = useMemo(()=>[
            {
                key: 'sendProposals',
                label: t.purposeSendProposals()
            },
            {
                key: 'automateBilling',
                label: t.purposeAutomateBilling()
            },
            {
                key: 'getPaidFaster',
                label: t.purposeGetPaidFaster()
            },
            {
                key: 'clientOnboarding',
                label: t.purposeClientOnboarding()
            },
            {
                key: 'engagementLetters',
                label: t.purposeEngagementLetters()
            },
            {
                key: 'updateAgreements',
                label: t.purposeUpdateAgreements()
            },
            {
                key: 'annualIncreases',
                label: t.purposeAnnualIncreases()
            },
            {
                key: 'collectPayments',
                label: t.purposeCollectPayments()
            },
            {
                key: 'reduceAdmin',
                label: t.purposeReduceAdmin()
            },
            {
                key: 'stayCompliant',
                label: t.purposeStayCompliant()
            }
        ], [
        t
    ]);
    const handleSubmit = useCallback(()=>{
        // TODO(ANC-13381): replace with real BI event id once assigned
        logBI(99999, {
            purposes: values.purposes,
            action: 'continue'
        });
        api.vendor.update({
            purposes: values.purposes
        }).catch(()=>{});
        onContinue();
    }, [
        api,
        logBI,
        onContinue,
        values.purposes
    ]);
    useImperativeHandle(submitRef, ()=>({
            submit: handleSubmit
        }), [
        handleSubmit
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.root,
        "data-testid": testIds.IntentStepTestIds.Root(),
        children: /*#__PURE__*/ _jsx(ChipCollection, {
            mode: "multi",
            options: options,
            value: values.purposes,
            onChange: (purposes)=>onChange(_object_spread_props(_object_spread({}, values), {
                    purposes
                })),
            testId: testIds.IntentStepTestIds.PurposeChip()
        })
    });
};
